import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

import user from '@/store/modules/user';
import frontEndSettings from '@/store/modules/frontEndSettings';
import ward from '@/store/modules/ward';
import organizations from '@/store/modules/organizations';
import contacts from "@/store/modules/contacts";

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    user,
    frontEndSettings,
    ward,
    organizations,
    contacts
  }
});
